import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { getAuthData } from '../../utils/auth';

const initialState: any = {
  cognito: {},
  dynamodb: {},
  status: 'idle',
};

export const fetchCognitoUser = createAsyncThunk(
  'user/fetchCognitoUser',
  async (params: any) => {
    return await getAuthData(params)
  }
);

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCognitoUser.pending, (state: any) => {
        state.status = 'loading';
      })
      .addCase(fetchCognitoUser.fulfilled, (state: any, { payload }: any) => {
        state.status = 'idle';
        state.cognito = payload;
      })
      .addCase(fetchCognitoUser.rejected, (state: any, { payload }: any) => {
        state.status = 'failed';
        console.error('Fetching user auth data failed.', payload)
      });
  },
});

export const selectCognitoUser = (state: RootState) => {
  return state?.user?.cognito;
};

export default userSlice.reducer;
